// testing

// src/routes/forgotPasswordRoute.jsx
import ForgotPassword from '../pages/Auth/ForgotPassword';

export const forgotPasswordRoute = {
  path: '/forgot-password',
  element: <ForgotPassword />
};